<template>
  <div></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { Diamonds } from './Diamonds'
export default {
  mixins: [O3DG2],
  methods: {
    setup () {
      this.diamonds = new Diamonds({
        renderer: this.ctx.renderer,
        onResize: this.onResize,
        onLoop: this.onLoop,
        getScreen: this.getScreen,
        scene: this.ctx.scene,
        camera: this.ctx.camera
      })
      // this.o3d.rotation.y = Math.PI * 0.5
      this.o3d.add(this.diamonds.o3d)
    }
  },
  beforeDestroy () {
    this.o3d.remove(this.diamonds.o3d)
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>
</style>
